<template>
  <div id="container">
    <van-pull-refresh style="padding:0 10px" v-model="refreshing" @refresh="reload">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="加载完成"
        @load="load"
      >
        <div class="card margin-tb-10" v-for="model in models" :key="model.id" @click="openModel(model)">
          <van-image
            width="100%"
            :src="model.thumb.url"
          />
          <h5>{{model.name}} <span class="pull-right color-describe"><small>{{model.describe}}</small></span></h5>
        </div>
      </van-list>
    </van-pull-refresh>
    <TabBar :active="0"/>
  </div>
</template>

<script>
import Api from '@/utils/api'
import TabBar from '@/components/TabBar.vue'
import wx from 'weixin-js-sdk'
export default {
  components: {
    TabBar
  },
  created () {
    let url = window.location.href
    Api.post('cus.user/weixin', null, () => {
      Api.post('wei.user/jsapi', {url: url}, res => {
        let data = res.data
        wx.config({
          debug: false,
          appId: data.appid,
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: '办公全能侠',
            desc: '精彩学员互动活动',
            link: 'https://wx.tbxprint.com/',
            imgUrl: 'https://wx.tbxprint.com/static/image/logo.jpg',
            success: function () { }
          })
        })
      })
    }, res => {
      if (res.code === 30000) this.$dialog.confirm({title: '尚未注册', message: '点击确定完成授权，享受更多权益'}).then(() => this.$router.push({path: '/passport'}))
      else this.$router.push({path: '/bind?uri=' + (this.$route.query.uri === undefined ? '/' : this.$route.query.uri)})
    })
  },
  data () {
    return {
      models: [],

      filter: {
      },

      loading: false,
      finished: false,
      refreshing: false,

      page: 0
    }
  },
  methods: {
    reload () {
      this.finished = false
      this.loading = true
      this.page = 0
      this.models = []
      this.load()
    },
    load () {
      this.page = this.page + 1
      let params = {page: this.page, limit: 10, type: 20, status: 100}
      Api.post('inf.article/models', params, res => {
        this.models = this.models.concat(res.data)

        this.refreshing = false
        this.loading = false
        if (this.models.length >= res.count) this.finished = true
      })
    },
    openModel (model) {
      if (model.href !== '') this.$router.push(model.href)
      else this.$router.push('/inf/article/model?id=' + model.id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue